import useSWR from 'swr';

import { IDetailResponse } from 'utils/types';

import { fetcher } from './utils';

type TagStatus = 'active';

export interface ITag {
  id?: number;
  name: string;
  state?: TagStatus;
  description: string;
}

export const useTagList = (params?: Record<string, any>) => {
  const { data, isLoading, isValidating, mutate, error } = useSWR<IDetailResponse<ITag[]>>(
    params ? { url: '/v4/dash/simple/tags', params } : { url: '/v4/dash/simple/tags?size=1000' },
    fetcher
  );

  return { data: data?.data, isLoading, isValidating, mutate, error };
};

export const useTag = (id?: number | string | null) => {
  const { data, isLoading, mutate, error } = useSWR<IDetailResponse<ITag>>(
    id ? `/v4/dash/tags/${id}` : null,
    fetcher
  );

  return { data: data?.data, isLoading, mutate, error };
};
